export enum InternalOrderEnums {

  //Estados
  open = 1,
  close = 2,
  annul = 3,


  // Permisos
  openPermission = 1,
  closePermission = 12,
  annulPermission = 3,
  exportExcel = 10
}